import { RequestError } from './types';

/**
 * Deterimine if a value is a RequestError.
 * @see RequestError
 * @param check The value to check.
 * @returns true if input is a RequestError instance.
 */
export const isRequestError = (check: unknown): check is RequestError => {
  if (typeof check !== 'object' || check === null) {
    return false;
  }
  const fnType = 'function';
  return (
    'message' in check &&
    typeof check.message === 'string' &&
    'source' in check &&
    typeof check.source === fnType &&
    'request' in check &&
    typeof check.request === fnType &&
    'response' in check &&
    typeof check.response === fnType
  );
};
